/**
 * Пути к 3D моделям, сгруппированные по типам оборудования
 */

export const MODEL_PATHS = {
    pools: [],
    technicalRoom: [],

    // Только файлы, которые реально лежат в public/models/pumps (иначе 404 в консоли)
    pumps: [
        '/models/pumps/aquatechnixpump.glb',
        '/models/pumps/bwtpump.glb',
        '/models/pumps/emauxpump.glb',
        '/models/pumps/glongpump.glb',
        '/models/pumps/nsepump.glb',
        '/models/pumps/pickspump.glb',
        '/models/pumps/poolking.glb',
        '/models/pumps/wlpump.glb'
    ],

    filters: [
        '/models/filters/filterfront.glb',
        '/models/filters/filterup.glb'
    ],

    heaters: [
        '/models/Heats/electiccoetas.glb',
        '/models/Heats/heat.glb',
        '/models/Heats/electricheat.glb',
        '/models/Heats/heatpump.glb'
    ],

    consoles: [
        '/models/consoles/console.glb'
    ],

    disinfection: [
        '/models/desindections/chlorinator1.glb',
        '/models/desindections/chlorinator2.glb',
        '/models/desindections/ultraviolet.glb'
    ],

    projectors: [
        '/models/projectors/projector.glb',
        '/models/projectors/trans.glb'
    ],

    ladders: [
        '/models/ladders/ladder2.glb',
        '/models/ladders/ladder3.glb',
        '/models/ladders/ladder4.glb',
        '/models/ladders/ladder5.glb',
        '/models/ladders/ladder6.glb',
        '/models/ladders/ladder8.glb',
        '/models/ladders/ladder10.glb',
        '/models/ladders/ladder12.glb'
    ],

    skimmers: [
        '/models/skimmers/skimmer10.glb',
        '/models/skimmers/skimmer50.glb',
        '/models/skimmers/skimmer130.glb',
        '/models/skimmers/skimmer140.glb',
        '/models/skimmers/skimmer180.glb'
    ],

    nozzles: [
        '/models/nozzles/nozzle.glb'
    ],

    drains: [
        '/models/drains/drain.glb'
    ],

    grates: [
        '/models/grates/grate.glb'
    ]
};

/** Блокирующая загрузка: один дефолтный насос; остальные насосы — в фоне */
const DEFAULT_CRITICAL_PUMP = '/models/pumps/glongpump.glb';

export const CRITICAL_MODELS = [
    DEFAULT_CRITICAL_PUMP
];

export const ADDITIONAL_MODELS = [
    ...MODEL_PATHS.pumps.filter((p) => p !== DEFAULT_CRITICAL_PUMP),
    ...MODEL_PATHS.filters,
    ...MODEL_PATHS.heaters,
    ...MODEL_PATHS.consoles,
    ...MODEL_PATHS.disinfection,
    ...MODEL_PATHS.projectors,
    ...MODEL_PATHS.ladders,
    ...MODEL_PATHS.skimmers,
    ...MODEL_PATHS.nozzles,
    ...MODEL_PATHS.drains,
    ...MODEL_PATHS.grates
];

/** Единый плоский список GLB для modelPreloader и прочих сервисов */
export const ALL_GLB_PRELOAD_PATHS = Array.from(new Set([...CRITICAL_MODELS, ...ADDITIONAL_MODELS]));
